import {
    fetchRouteInformation,
    getFilterData,
    getRouteData, getStageTaskPlanList,
    sideLineRoute,
    unassignStager, updateStageTaskPlanStatus
} from "../network/StageNetworkAPI";
import {getDataWithExpiry, isRouteCacheValid, setDataWithExpiry} from "../../util/CacheManager";
import {ROUTE_DATA_CACHE_KEY} from "../../util/LocalStorageKeys";
import {DEFAULT_CAPABILITIES} from "../../util/Constants";
import {getStationCode} from "../../network/NetworkUtil";
import {
    logCounterMetric,
    ROUTE_CACHE_HIT_METRIC,
    ROUTE_CACHE_MISS_METRIC,
    STAGE_TAB_METRIC_KEY
} from "../../util/MetricUtil";

export const RouteStageReducer = (state, action) => {
    switch(action.type) {
        case "LOAD_VIEW":
        {
            const {dispatcher, filterDispatcher, capability, xptNodes, stationConfig} = action.data;
            if (DEFAULT_CAPABILITIES.includes(capability)) {
                //try to load data from cache if xpt filters and ttl is valid.
                if (isRouteCacheValid(xptNodes)) {
                    const {cachedData, lastUpdated} = getDataWithExpiry(ROUTE_DATA_CACHE_KEY);
                    logCounterMetric(getStationCode(), STAGE_TAB_METRIC_KEY, ROUTE_CACHE_HIT_METRIC);
                    dispatcher({type: "RECEIVE_DATA",
                        data: { ...getRouteData(cachedData.response.routes, capability, stationConfig), lastUpdated: lastUpdated}
                    });
                    filterDispatcher({type: "RECEIVE_FILTER_DATA", data: getFilterData(cachedData.response.routes)})
                    return state
                } else {
                    logCounterMetric(getStationCode(), STAGE_TAB_METRIC_KEY, ROUTE_CACHE_MISS_METRIC);
                }
            }
            fetchRouteInformation(action.data)
            return state
        }
        case "LOAD_STAGE_PLAN_TASKS":
        {
            const {baseUrl, stationConfig, dispatcher} = action.data;
            getStageTaskPlanList(baseUrl, stationConfig, dispatcher)
            return state
        }
        case "UPDATE_STAGE_TASK_PLAN_STATUS":
        {
            const {baseUrl, stationConfig, dispatcher, planId, status, forceUpdate, cycleName} = action.data;
            updateStageTaskPlanStatus(baseUrl, stationConfig, dispatcher, planId, status, forceUpdate, cycleName)
            return state
        }
        case "SHOW_ROUTE_ADJUSTMENT_PENDING":
        {
            return {
                ...state,
                showPendingConfirmation: true,
                pendingConfirmationData: action.data
            }
        }
        case "CLEAR_PENDING_CONFIRMATION":
        {
            return {
                ...state,
                showPendingConfirmation: false,
                pendingConfirmationData: null
            }
        }
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "UPDATE_ROUTE_DATA_CACHE":
        {
            setDataWithExpiry(ROUTE_DATA_CACHE_KEY, action.data);
            return state
        }
        case "SIDELINE_ROUTE":
        {
            const {dispatcher, routeId, stationCode, baseUrl, stationConfig} = action.data;
            sideLineRoute(dispatcher, routeId, stationCode, baseUrl, stationConfig)
            return state
        }
        case "UNASSIGN_STAGER":
        {
            const {dispatcher, stageListId, stationCode, associateId, baseUrl, stationConfig} = action.data;
            unassignStager(dispatcher, stageListId, stationCode, associateId, baseUrl, stationConfig)
            return state
        }
        case "SHOW_NOTIFICATION":
            return {...state, ...action.data};
        case "ROUTE_SIDELINED_SUCCESS":
            return {...state, ...action.data};
        case "ROUTE_SIDELINED_ERROR":
            return {...state, ...action.data};
        case "REMOVE_NOTIFICATION":
            const notification = {alert: {}}
            return {...state, ...notification};
        case "ALREADY_SIDELINED":
            return {...state, ...action.data};
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/stageStatus/reducers/RouteStageReducer.js